import { SongDeal, SongKeyDates, SongProjectTrack } from '~/models/music/music.dto';
import { contractSubTypeList } from '~/models/deals/DealDetails.dto';
import { ContactsListItem } from '~/models/contacts.dto';

export class Deal {
    assetCode!: string;
    incomeType!: string;
    dealType!: string;
    contractType!: DealStatus | string;
    title!: string;
    company!: string;
    contactDisplayContract?: string | null;
    incomePeriod!: { start: string; end: string } | null;
    statementDate!: string | null;
    contractBalance!: number | null;
    balanceCurrency!: Currency;
    terms!: { date?: string; condition?: string };
    description!: string;
    keyDates!: { title: string; dates: string[] }[];
    keyDates2!: { title: string; dates: string[] }[];
    paymentDates!: { title: string; dates: string[] }[];
    advancesDates!: { title: string; dates: string[] }[];
    royaltyRates!: { title: string; percent: number; region: string; }[];
    royaltyStatement!: RoyaltyStatement;
    recoupableItems!: { title: string; percent: any; region: string; }[];
    deliveredProductTypes!: string[];
    contractDate!: string;
    paymentNotes?: string;
    notes!: string[];
    address!: string;
    image!: string;
    addLine1Contract!: string;
    addLine2Contract!: string;
    addLine3Contract!: string;
    addLine4Contract!: string;
    emailAddressContract!: string;
    signatureDate!: string;
    companyContactCode!: any;
    contractSubTypeList?: contractSubTypeList[];
    legalContact!: number | null;
    companyContact!: number | null;
    contacts!: ContactsListItem[];
}

export class DealSummary {
    dealSongLinkFlag!: string;
    assetCode!: string;
    incomeType!: string;
    dealType!: string;
    contractType!: DealStatus | string;
    title!: string;
    company!: string;
    incomePeriod!: { start: string; end: string } | null;
    statementDate!: string | null;
    contractBalance!: number | null;
    balanceCurrency!: Currency;
    terms!: { date?: string; condition?: string };
    description!: string;
    keyDates!: { title: string; dates: string[] }[];
    paymentDates!: { title: string; dates: string[] }[];
    advancesDates!: { title: string; dates: string[] }[];
    royaltyRates!: { title: string; percent: number }[];
    royaltyStatement!: RoyaltyStatement;
    recoupableItems!: string[];
    deliveredProductTypes!: string[];
    contractDate!: string;
    notes!: string[];
    address!: string;
    image!: string;
}
export class SongSummary {
    dealSongLinkFlag!: number;
    projectId!: number;
    assetCode!: string;
    songArtist!: string;
    songArtistImage!: string;
    songName!: string;
    writingShare!: number;
    releaseDate!: string | null;
    label!: string;
    showSongStatus!: string;
    showSongDealStatus!: string;
    gSongEntryId!: number;
    step!: number;
    totalRows!: number;
}

export enum DealStatus {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE',
}

export class RoyaltyStatement {
    royaltyCollection!: string;
    paidTo!: string;
    logIn!: string;
    password!: string;
}

export class Company {
    id!: string;
    name!: string;
    logo!: string;
}

export enum Currency {
    EUR = 'EUR',
    USD = 'USD',
}

export class Contract {
    id!: string;
    name!: string;
    company!: Company;
    createDate!: string;
    nextStatementDate!: string;
    status!: string;
    amount?: number;
    amountCurrency!: Currency;
}

export class MusicEntityMeta {
    artist!: string;
    artistImage!: string;
    featArtists!: string[];
    title!: string | null;
    releaseDate!: string | null;
    description!: { title: string; text: string };
}

export class MusicEntity {
    id!: string;
    dealId!: Deal['assetCode'];
    connectedDeals!: SongDeal[];
    keyDates!: SongKeyDates[];
    meta!: MusicEntityMeta;
    roles!: string[];
    writingSharePercent!: string;
    label!: string;
    dealDeliveredTo!: string;
    ISRC!: string;
    UPC!: string;
    gSongReleaseYear!: string | null;
    releaseDate!: string | null;
    dates!: { title: string; date: string }[];
    audits!: { title: string; date: string }[];
    assets!: { title: string; tags: string[] }[];
    gSongFeatArtist1!: string;
    gSongFeatArtist2!: string;
    gSongFeatArtist3!: string;
    gMyWriterName!: string | null;
    gPublisherName!: string | null;
    writingShare!: any;
    publishingShare!: any;
    gSongFirstDeal!: string;
    neighbouringRights!: any;
    otherEligible!: any;
    publishing!: any;
    masters!: any;
    writerShareEligible!: any;
    songProjectTrack!: SongProjectTrack[];
}
